export const BNP_ADMIN_PRIVILEGE = "BNP_ADMIN_PRIVILEGE";
export const REPORTING_MANAGER_PRIVILEGE = "REPORTING_MANAGER_PRIVILEGE";
export const BNP_DELPHIUS_LEGACY_OG_ADMIN_CLAIM = "BNP_DELPHIUS_LEGACY_OG_ADMIN_CLAIM";
export const REPORTING_ADMIN_CLAIM = "REPORTING_ADMIN_CLAIM";
export const BNP_WORKFLOWS_ADMIN_PRIVILEGE = "BNP_WORKFLOWS_ADMIN_PRIVILEGE";
export const BNP_WORKFLOW_APPROVER_PRIVILEGE = "BNP_WORKFLOW_APPROVER_PRIVILEGE";
export const BNP_FORM_SUBMISSION_PRIVILEGE = "BNP_FORM_SUBMISSION_PRIVILEGE";
export const BNP_MILESTONE_ADMIN_PRIVILEGE = "BNP_MILESTONE_ADMIN_PRIVILEGE";
export const BNP_TASK_ASSIGNEE_ONLY_PRIVILEGE = "BNP_TASK_ASSIGNEE_ONLY_PRIVILEGE";
